import { useMemo } from "react";

export default function useTeamMembersByRole({ team, role }) {
	return useMemo(() => {
		return Object.values(team || {}).filter((member) => member.role === role);
	}, [team, role]);
}
